var version = '6.4.4';

module.exports = version;
